//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import HiHeader from "../../components/header/Index.vue";
import HiButton from "../../components/button/Index.vue";
import HiCell from "../../components/cell/Index.vue";
import InstagramUserItem from "../../components/plan/instagram_user_item/Index.vue";
import { mapGetters } from "vuex";
import { CURRENT_USER_INFO_SIMPLE } from "../../store/mutation-types";
import { showErrorMsg } from "../../utils/error";

export default {
  name: "AssignInstagramPage",
  components: { HiHeader, HiButton, InstagramUserItem, HiCell },
  data() {
    return {
      selectIds: [],
    };
  },
  methods: {
    /**
     * 删除对应instamgram item
     * @param item 选中项
     * @returns {Promise<void>}
     */
    async delClick(item) {
      try {
        await this.$confirm.show(this.$t("common.delTitle"));
        this.$loading.show();
        await item.remove();
        this.$toast.show({ message: this.$t("common.success") });
      } catch (e) {
        showErrorMsg(e);
      } finally {
        this.$loading.hide();
      }
    },
  },
  computed: {
    ...mapGetters({
      user: CURRENT_USER_INFO_SIMPLE,
    }),
    /**
     * 获取当前member详情
     */
    detail() {
      const detail = this.user.teamMemberList.find(
        (t) => Number(t.id) === Number(this.$route.params.id)
      );
      return detail;
    },
    /**
     * 计算列表
     * @returns {Array}
     */
    list() {
      // 根据类型进行分组(过滤掉member)
      let types = [];
      this.detail.publishers.forEach((l) => {
        let typeItem = types.find((t) => t.isPremium === l.isPremium);
        if (typeItem) {
          typeItem.items.push(l);
        } else {
          let title = l.isPremium
            ? this.$t("addUnlimitedAccountPage.memberUserType")
            : this.$t("addUnlimitedAccountPage.freeUserType");
          types.push({ isPremium: l.isPremium, title, items: [l] });
        }
      });
      return types;
    },
  },
};



// WEBPACK FOOTER //
// ./src/pages/team_member/InstagramMore.vue